/**
 * The customizer's page furniture: the always-on-screen open button and the
 * empty #customizer div the panel mounts into.  The panel itself -- markup,
 * CSS, behaviour -- lives in packages/client/src/customizer/panel.js and injects its
 * own <style>; this module owns only the door in.
 */
import "./customizer.css";
import { mount } from "./dom.js";

export function mountCustomizerButton() {
  return mount(`
<!-- Deliberately OUTSIDE #hud.  The cat switcher in there is a developer
     affordance and is hidden until Backquote; the cat builder is a feature
     the player is meant to find, so its button cannot live in a panel that
     is invisible during normal play. -->
<button id="open-customizer" class="panel" type="button">Customise your cat &middot; B</button>`);
}

export function mountCustomizerHost() {
  return mount(`
<div id="customizer"></div>`);
}
